import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect, useState, useRef } from 'react';
import { requestTimeout, clearRequestTimeout } from '@essentials/request-timeout';
export var useDebounceCallback = function useDebounceCallback(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var timeout = useRef(null); // cleans up pending timeouts when the function changes

  function _ref() {
    if (timeout.current !== null) {
      clearRequestTimeout(timeout.current);
      timeout.current = null;
    }
  }

  useEffect(function () {
    return _ref;
  }, [fn, wait]);
  return useCallback(function () {
    var this_ = this;
    var args = arguments;
    if (timeout.current === null && leading === true) fn.apply(this_, args);else if (timeout.current !== null) clearRequestTimeout(timeout.current);
    timeout.current = requestTimeout(function () {
      timeout.current = null;
      leading !== true && fn.apply(this_, args);
    }, wait);
  }, [fn, wait]);
};
export var useDebounce = function useDebounce(initialState, wait, leading) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return [state, useDebounceCallback(setState, wait, leading)];
};
export default useDebounce;